<template>
  <div class="commonet-div theme_background3_color">
    <div class="icon-title">
      <img :src="icon" />
    </div>
    <div class="text theme_font_color">
      <p>{{content}}</p>
    </div>
    <p class="user theme_font_color">——  {{user}}</p>
  </div>
</template>

<script>
export default {
  props: ['data', 'icon', 'content', 'user'],
  name: 'CommentDiv',
  data() {
    return {}
  },
}
</script>
<style lang="less" scoped>
.commonet-div {
  width: 440px;
  height: 362px;
  box-shadow: 0px 0px 20px 0px rgba(114, 64, 0, 0.1);
  padding: 17px 40px 30px;
  filter: blur(0px);
  display: inline-block;
  margin: 0 20px;
  position: relative;
  z-index: 999;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  flex-shrink: 0;

  .text {
    font-size: 16px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    letter-spacing: 2px;
    margin: 17px 0 20px;
    height: 65%;
    width: 100%;
    line-height: 26px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 8;
    display: -webkit-box;
    display: -ms-box;
    display: -moz-box;
    p {
      white-space: normal;
      word-break: break-all;
    }
  }
  .user {
    text-align: right;
    text-align: -webkit-right;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 22px;
    position: absolute;
    bottom: 30px;
    width: 100%;
    right: 40px;
  }
}
@media only screen and (max-width: 620px) {
  .commonet-div {
    width: 350px !important;
    height: 420px !important;
    padding: 10px 20px 20px !important;
    .user {
      bottom: 20px;
      right: 20px !important;
    }
  }
}
</style>
